/**
 * Преобразует в человекопонятный вид чисел с разбивкой на разряды (1 000 000)
 *
 * @param amount
 * @param fixed
 * @param currency
 * @returns {string}
 */
import _ from "lodash";

interface IAmountFormatOptions {
    currencyBefore?: string | null,
    currencyAfter?: string | null,
    toFixed?: boolean,
    withLetters?: boolean,
    withSign?: boolean,
}

const amountFormat = (amount: number | string = 0, fixed = 2, currency: string | null = null, withLetters: boolean = false, options: IAmountFormatOptions = {}) => {
    amount = parseFloat(String(amount));
    options.currencyBefore = options.currencyBefore || currency || '';
    options.withLetters = options.withLetters || withLetters;
    options.withSign = options.withSign || false;
    let letter = '';
    const currencyAfter = options.currencyAfter || '';
    if (options.withLetters) {
        if (Math.abs(amount) >= 1000000000000) {
            fixed = 1;
            letter = 'T';
            amount = _.round(amount / 1000000000000, 1);
        } else if (Math.abs(amount) >= 1000000000) {
            fixed = 1;
            letter = 'B';
            amount = _.round(amount / 1000000000, 1);
        } else if (Math.abs(amount) >= 1000000) {
            fixed = 1;
            letter = 'M';
            amount = _.round(amount / 1000000, 1);
        } else if (Math.abs(amount) >= 1000) {
            fixed = 1;
            letter = 'K';
            amount = _.round(amount / 1000, 1);
        }
    }
    let sign = '';
    if (options.withSign) {
        sign = amount > 0 ? '+' : amount < 0 ? '-' : '';
        amount = Math.abs(amount);
    } else if (options.currencyBefore) {
        sign = amount < 0 ? '-' : '';
        amount = Math.abs(amount);
    }
    const amountStr = options.toFixed ? amount.toFixed(fixed) : _.round(amount, fixed).toString();
    return `${sign}${options.currencyBefore}` + amountStr.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ') + letter + currencyAfter;
}

export default amountFormat;